import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { OrderHistoryData } from '../../core/state/order/order.types';
import { getOrderHistory } from '../../core/state/order/orderMiddleware';
import { utils } from '../../utils';
import * as Data from '../../weborder/Data';
import * as Store from '../../weborder/Store';
import { OrderHistory as RedesignOrderHistory } from './OrderHistory';

export type DispatchProps = ReturnType<typeof mapDispatchToProps>;
export type StateProps = {
  afterProfilePanelUrl: string;
  currentLang: string;
  lastRestaurantUrl: string;
  ordersHistory: Data.Async<OrderHistoryData[]>;
  translate: any;
};

const numberOfUsersPreviousOrders = 50;

const mapStateToProps = (state: Store.State): StateProps => {
  const currentLang = utils.get.activeLanguageCode(state.locale.languages);

  return {
    afterProfilePanelUrl: state.general.afterProfilePanelUrl,
    currentLang,
    lastRestaurantUrl: state.flipdish.LastRestaurantUrl,
    ordersHistory: state.orders.history,
    translate: getTranslate(state.locale),
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<Store.State, {}, Action>,
) => ({
  actions: {
    getOrderHistory: (): void => {
      dispatch(getOrderHistory(numberOfUsersPreviousOrders));
    },
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RedesignOrderHistory);
